import {
  useCurrentLanguage,
  useIsLoadingLanguage,
  useLoadTranslations,
  useSetLanguage,
  useT,
} from "@/stores/language";
import { useEffect } from "react";

/**
 * Hook to manage the translations using Zustand store
 * @returns The current language, whether the translations are loading, and the translation function
 */
export function useTranslation() {
  const t = useT();
  const setLanguage = useSetLanguage();
  const currentLanguage = useCurrentLanguage();
  const isLoading = useIsLoadingLanguage();
  const loadTranslations = useLoadTranslations();

  useEffect(() => {
    loadTranslations();
  }, [loadTranslations]);

  return {
    t,
    setLanguage,
    currentLanguage,
    isLoading,
  };
}

